<template>
  <div
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    style="min-width: 200px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div class="input-group">
      <v-layout row wrap>
        <v-icon
          v-if="answer.status"
        >
          {{ statusIconClass }}
        </v-icon>
        <v-flex
          v-for="(option, index) in fieldType.options"
          :key="option.id"
          xs12
          :sm6="optionListMaxLen <= 150"
          :md3="optionListMaxLen <= 150"
          :class="{'single-col-opt': optionListMaxLen > 150}"
          v-bind:style="(answer.status === 'follow up' || highlightNoAnswer) ? 'background:#ffffcc;display:inline-block;' : 'display:inline-block;'"
        >
          <v-checkbox
            v-model="value"
            :value="option.id"
            :label="option.text"
            :aria-label="fieldType.text || question.text"
            :disabled="readonly"
            style="display:inline-block;padding-left:25px;"
            @change="save"
            :rules="isRequired ? [value.length > 0 || 'Required'] : []"
            :hide-details="index != 0"
          />
        </v-flex>
      </v-layout>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'DropdownAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      value: [],
      savedValue: null,
      failed: false,
      menu: false
    }
  },
  beforeMount () {
    this.value = this.answer.options || []
  }
}

</script>

<style>
.checkContainer {
    padding:5px;
    padding-left:25px;
}

.follow-up div .checkContainer {
  background-color: #ffffcc;
  border: 1px solid #ccc;
}

.single-col-opt {
  margin-bottom: 15px;
}
</style>
